import { render, staticRenderFns } from "./recentlyMatter.vue?vue&type=template&id=aca9deb2&scoped=true&"
import script from "./recentlyMatter.vue?vue&type=script&lang=js&"
export * from "./recentlyMatter.vue?vue&type=script&lang=js&"
import style0 from "./recentlyMatter.vue?vue&type=style&index=0&id=aca9deb2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca9deb2",
  null
  
)

export default component.exports